import { useState } from "react";
import { useTranslation } from "react-i18next";

import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";
import CompanyDialog from "../dialogTypes/CompanyDialog";
/**
 * @COMPONENT_NAME CompanyUpdateButton
 * @DESCRIPTION 기존 회사 레코드 수정을 위한 버튼 컴포넌트. 회사 수정 폼이 포함된 다이얼로그를 엽니다.
 *
 * @PROPS
 *    - {string} id - 버튼 식별자
 *    - {Object} schema - 폼 스키마 구성
 *    - {Object} grid - 그리드 컴포넌트 참조
 *    - {Object} refresh - 그리드 새로고침 함수
 *    - {Function} onClose - 다이얼로그 닫힐 때 호출
 *    - {Function} onSuccess - 수정 성공 시 호출
 *    - {string} createButtonName - 커스텀 버튼명
 *    - {Function} customizeErrorMsgCallback - 커스텀 오류 메시지 콜백
 *    - {Function} setInitialDataCallback - 초기 데이터 설정 콜백
 *    - {Function} modifyUrlCallback - URL 수정 콜백
 *
 * @PASSTHROUGH_PROPS
 *    - {Object} others - 버튼 레이아웃에 전달되는 추가 props
 *
 * @CALLBACKS
 *    - {Function} onOpen - 버튼 클릭 시 호출
 *    - {Function} onDialogClose - 다이얼로그 닫힐 때 호출
 *    - {Function} onUpdateSuccess - 수정 성공 시 호출
 *
 * @EXAMPLES
 * ```jsx
 * <CompanyUpdateButton
 *   id="company-update"
 *   schema={schema}
 *   grid={grid}
 *   refresh={refresh}
 *   onSuccess={handleSuccess}
 * />
 * ```
 */
function CompanyUpdateButton(props) {
    const { t } = useTranslation();

    const {
        id,
        schema,
        grid,
        refresh,
        onClose,
        onSuccess,
        createButtonName,
        customizeErrorMsgCallback,
        setInitialDataCallback,
        modifyUrlCallback,
        ...others
    } = props;
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    const onOpen = () => {
        if (grid) {
            setFormData({ ...grid.selectedItems[0] });
        }

        setOpen(true);
    };

    const onDialogClose = () => {
        setOpen(false);

        if (onClose) {
            onClose();
        }
    };

    const onUpdateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <>
            <UpdateRecordButtonLayout id={id + "update-button"} onClick={onOpen} {...others} />
            <CompanyDialog
                id={id + "update-dialog"}
                mode="edit"
                method="put"
                formId={id + "update-form"}
                initialData={formData}
                title={schema ? t(`dialog.title.MomSysUdtCompany.update`) : ""}
                schema={schema}
                open={open}
                onClose={onDialogClose}
                onSuccess={onUpdateSuccess}
            />
        </>
    );
}

export default CompanyUpdateButton;
